const { REACT_APP_API_BASE_URL } = process.env;

export const getEmployments = (token, query) => new Promise((resolve, reject) => {
  const queryParams = new URLSearchParams({
    results: 10,
    ...query
  }).toString();
  
  const request = new Request(REACT_APP_API_BASE_URL + '/employments?' + queryParams, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const getEmployment = (token, id) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/employments/' + id, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const createEmployment = (token, employment) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/employments', {
    method: 'POST',
    body: JSON.stringify({ employment }),
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const updateEmployment = (token, id, employment) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/employments/' + id, {
    method: 'PUT',
    body: JSON.stringify({ employment }),
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const uploadEmploymentFile = (token, id, file) => new Promise((resolve, reject) => {
  const data = new FormData();
  data.append('file', file);

  const request = new Request(`${REACT_APP_API_BASE_URL}/employments/${id}/file`, {
    method: 'PUT',
    body: data,
    headers: {
      'Authorization': 'Bearer ' + token
    }
  });

  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});
